(function(){
  /* WildBoard "Launching soon" pre-launch treatment. Reversible: unlink wb-launch.js
     + wb-launch.css from wb-header when the pre-sale goes live. (07.25.2026, Amy) */
  var BADGE="Board's almost ready";
  var BTN="Launching soon";
  var PUB="Szg4iA", REV="2024-10-15", LIST="Xz4VPt"; /* Klaviyo Product Wait List */
  var OKMSG="You're on the list. We'll email you the second the board is ready.";

  function kSub(email){
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+PUB,{
      method:"POST", keepalive:true,
      headers:{"revision":REV,"Content-Type":"application/json"},
      body:JSON.stringify({data:{type:"subscription",attributes:{custom_source:"Launching soon (site)",profile:{data:{type:"profile",attributes:{email:email}}}},relationships:{list:{data:{type:"list",id:LIST}}}}})
    });
  }

  /* ---------- Notify-me modal ---------- */
  var modal=null;
  function buildModal(){
    if(modal) return modal;
    modal=document.createElement("div");
    modal.className="wb-soon-modal";
    modal.setAttribute("hidden","");
    modal.innerHTML='<div class="wb-soon-ov" data-close></div>'+
      '<div class="wb-soon-card" role="dialog" aria-modal="true" aria-label="Join the waitlist">'+
        '<button type="button" class="wb-soon-x" data-close aria-label="Close">×</button>'+
        '<div class="wb-soon-ey">Board’s almost ready</div>'+
        '<h3 class="wb-soon-h">Get the first bite.</h3>'+
        '<p class="wb-soon-p">Drop your email and we’ll tell you the moment the board is live. Early access, first dibs.</p>'+
        '<form class="wb-soon-form" novalidate>'+
          '<label class="visually-hidden" for="wbSoonEmail" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)">Email address</label>'+
          '<input id="wbSoonEmail" type="email" class="wb-soon-inp" placeholder="you@email.com" autocomplete="email" required>'+
          '<button type="submit" class="wb-soon-btn">Notify me</button>'+
        '</form>'+
        '<p class="wb-soon-msg" role="status"></p>'+
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener("click",function(e){ if(e.target && e.target.hasAttribute("data-close")) closeModal(); });
    var form=modal.querySelector(".wb-soon-form");
    form.addEventListener("submit",function(e){
      e.preventDefault();
      var inp=modal.querySelector(".wb-soon-inp"), msg=modal.querySelector(".wb-soon-msg");
      var email=(inp.value||"").trim();
      if(!email || email.indexOf("@")<1){ msg.textContent="Please enter a valid email address."; msg.className="wb-soon-msg err"; return; }
      var b=form.querySelector(".wb-soon-btn"); b.disabled=true; msg.textContent="";
      kSub(email).then(function(r){
        if(r.status>=200 && r.status<300){ form.setAttribute("hidden",""); msg.textContent=OKMSG; msg.className="wb-soon-msg ok"; }
        else { b.disabled=false; msg.textContent="Something hiccuped. Try again in a sec."; msg.className="wb-soon-msg err"; }
      }).catch(function(){ b.disabled=false; msg.textContent="Something hiccuped. Try again in a sec."; msg.className="wb-soon-msg err"; });
    });
    document.addEventListener("keydown",function(e){ if(e.key==="Escape") closeModal(); });
    return modal;
  }
  function openModal(){ buildModal(); modal.removeAttribute("hidden"); document.documentElement.style.overflow="hidden"; var i=modal.querySelector(".wb-soon-inp"); if(i) setTimeout(function(){ try{i.focus();}catch(e){} },50); }
  function closeModal(){ if(modal){ modal.setAttribute("hidden",""); document.documentElement.style.overflow=""; } }

  /* ---------- Relabel + lock the buy controls on all three surfaces ---------- */
  function labelNode(el){ return el.querySelector(".button__label,[data-label],.btn__label") || el; }
  function lock(el){
    if(!el) return;
    el.classList.add("wb-soon-cta");
    el.setAttribute("aria-disabled","false");
    if(el.hasAttribute("disabled")) el.removeAttribute("disabled");
    var lab=labelNode(el);
    if((lab.textContent||"").trim()!==BTN) lab.textContent=BTN;   /* re-applies over the builder's own render() */
    el.dataset.wbSoon="1";
  }
  function textLooksBuy(el){
    var t=(el.textContent||"").trim().toLowerCase();
    return /(^add\b|add to|add \d|to cart|to bag|add board|subscribe|buy now|save your seat|proceed to checkout)/.test(t);
  }
  function scan(){
    /* explicit WildBoard add controls: board builder + flavor-card 3-packs */
    document.querySelectorAll("[data-add],[data-add3]").forEach(lock);
    /* PDP buy area */
    document.querySelectorAll("#wbpdp button, #wbpdp a.btn, #wbpdp [name=\"add\"]").forEach(function(el){ if(textLooksBuy(el)) lock(el); });
    /* any standard Shopify add-to-cart form submit */
    document.querySelectorAll(".product-form__submit, form[action*=\"/cart/add\"] button[type=\"submit\"], form[action*=\"/cart/add\"] input[type=\"submit\"]").forEach(lock);
  }

  /* intercept the click before the section's own handler adds to cart */
  document.addEventListener("click",function(e){
    var t=e.target;
    if(t && t.closest && t.closest(".wb-soon-modal")) return;
    var el=t && t.closest && t.closest(".wb-soon-cta,[data-add],[data-add3]");
    if(!el) return;
    e.preventDefault(); e.stopPropagation();
    openModal();
  },true);

  /* ---------- Badges ---------- */
  function makeBadge(){ var b=document.createElement("span"); b.className="wb-launch-badge"; b.textContent=BADGE; return b; }
  function addBadges(){
    document.querySelectorAll("#wbpdp .buy, .wb-wg-flavors .flav .txt, .wb-wg-builder .build-head").forEach(function(c){
      if(c.dataset.wbBadge) return; c.dataset.wbBadge="1"; c.insertBefore(makeBadge(), c.firstChild);
    });
  }

  /* ---------- Boot + keep applied as sections re-render ---------- */
  var raf=null;
  function run(){ try{ scan(); addBadges(); }catch(e){} }
  function schedule(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=null; run(); }); }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",run); else run();
  try{
    var mo=new MutationObserver(schedule);
    mo.observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  }catch(e){}
})();
